module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Dress-0c73381f234b12a5bdc371fd298d4771.svg";